import * as React from 'react';
import classNames from 'classnames';
import {PropsWithChildren} from "react";

export interface IFormListProps extends PropsWithChildren {
    theme?: 'elevated';
    separated?: boolean;
    size?: 'wide' | 'narrow' | 'default' | 'full';
    className?: string;
}

const FormList: React.FunctionComponent<IFormListProps> = (props) => {
    return (
        <ul className={classNames(
            'form-list', props.className,
            {
                'elevated': props.theme === 'elevated',
                'margt': props.separated,
                'wide': props.size === 'wide',
                'narrow': props.size === 'narrow',
                'full': props.size === 'full',
            }
        )}>
            {props.children}
        </ul>
    );
};

FormList.displayName = 'FormList';

export default FormList;
